module.exports = __webpack_public_path__ + "img/dialog-img-03.93ae88a9.png";